import { useContext } from 'react';
import { PageContext } from 'contexts';
import { useSelector } from 'react-redux';
import { localeSelector } from 'store/selectors/locale';
import { MusicLink } from 'components/MusicLink';
import { COOKIE_NOTICE_LINKS_MAP } from 'constants/locales';
import { GO_COOKIE_NOTICE } from 'constants/metrics';
import { FormattedMessage } from 'react-intl';

const CookieNotice = () => {
  const page = useContext(PageContext);
  const locale = useSelector(localeSelector);
  return (
    <MusicLink
      href={COOKIE_NOTICE_LINKS_MAP[locale]}
      kind="accent"
      data-id={`${GO_COOKIE_NOTICE}-${page}`}
    >
      <FormattedMessage id="cookie-notice" defaultMessage="Cookie Notice" />
    </MusicLink>
  );
};

export default CookieNotice;
